export const jsonToFormData = (json = {}, objectKey = '') => {
  const formData = new FormData();

  const appendFormData = (data, parentKey = '') => {
    if (data === null) {
      formData.append(parentKey, '');
    } else if (typeof data === 'boolean') {
      formData.append(parentKey, data.toString())
    } else if (data instanceof Date) {
      formData.append(parentKey, data.toISOString());
    } else if (data instanceof File) {
      formData.append(parentKey, data);
    } else if (data && typeof data === 'object' && !Array.isArray(data)) {
      Object.keys(data).forEach(key => {
        appendFormData(data[key], parentKey ? `${parentKey}[${key}]` : key);
      });
    } else if (Array.isArray(data)) {
      data.forEach((item, index) => {
        if (item && typeof item === 'object') {
          appendFormData(item, `${parentKey}[${index}]`);
        } else {
          formData.append(`${parentKey}[]`, item);
        }
      });
    } else {
      formData.append(parentKey, data ? data : '');
    }
  }

  Object.keys(json).forEach(key => {
    appendFormData(json[key], objectKey ? `${objectKey}[${key}]` : key);
  });

  return formData;
}
